import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "d8297VQLktBGY/lB9nH1oGk", "NameDB", undefined);

var NameDB = /*#__PURE__*/function () {
  function NameDB() {
    _defineProperty(this, "nameDB", []);
  }

  var _proto = NameDB.prototype;

  // onLoad () {}
  _proto.start = function start() {};

  _proto.parseData = function parseData(data) {
    var nameArr = data.split(",");
    this.nameDB = nameArr;
    data = null;
  }
  /**随机名字*/
  ;

  _proto.randomName = function randomName() {
    var index = Math.floor(Math.random() * this.nameDB.length);
    return this.nameDB[index];
  } // update (dt) {}
  ;

  _createClass(NameDB, null, [{
    key: "I",
    get: function get() {
      if (!NameDB._instance) {
        NameDB._instance = new NameDB();
      }

      return NameDB._instance;
    }
  }]);

  return NameDB;
}();

_defineProperty(NameDB, "_instance", null);

export { NameDB as default };

_cclegacy._RF.pop();